import { Box, Divider, Typography, useTheme } from '@mui/material';
import { generateClient, SelectionSet } from 'aws-amplify/api';
import React, { useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import { Schema } from '../../../../amplify/data/resource';
import FileList from './FileList/FileList';

const fileSelectionSet = [
  'id',
  'createdAt',
  'status',
  'salaryMonth',
  'paymentDate',
  'lastSentToMislaka',
  'user.companyName',
  'user.companyRegistrationNumber',
] as const;

const depositSelectionSet = [
  'id',
  'totalDepositAmount',
  'fundIdentifier',
  'fundNameAtEmployer',
] as const;

const employeeSelectionSet = [
  'id',
  'depositId',
  'firstName',
  'lastName',
  'employeeId',
  'salaryMonth',
] as const;

const fundContributionSelectionSet = [
  'id',
  'employeeId',
  'contributionType',
  'contributionAmount',
  'contributionRate',
  'exemptPayments',
  'registryIdentifier',
  'previousRegistryIdentifier',
  'status',
  'error',
] as const;

// @ts-ignore
type File = SelectionSet<Schema['File']['type'], typeof fileSelectionSet>;

// @ts-ignore
type Deposit = SelectionSet<Schema['Deposit']['type'], typeof depositSelectionSet>;

// @ts-ignore
type Employee = SelectionSet<Schema['Employee']['type'], typeof employeeSelectionSet>;

// @ts-ignore
type FundContribution = SelectionSet<Schema['FundContribution']['type'], typeof fundContributionSelectionSet>;

type FileWithRelatedData = File & {
  employees: Employee[];
  deposits: Deposit[];
  fundContributions: FundContribution[];
};

const apiClient = generateClient<Schema>();

const Assignments: React.FC = () => {
  const theme = useTheme();
  const [files, setFiles] = useState<FileWithRelatedData[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFilesWithRelatedData = async () => {
      try {
        setLoading(true);

        // Сначала получаем все файлы
        const filesResponse = await apiClient.models.File.list({
          selectionSet: fileSelectionSet,
        });

        const filesData = filesResponse.data || [];
        
        // Для каждого файла параллельно загружаем связанные данные
        const filesWithRelatedData = await Promise.all(
          filesData.map(async (file: File) => {
            // Параллельно загружаем employees, deposits и fundContributions для каждого файла
            const [employeesResponse, depositsResponse, fundContributionsResponse] = await Promise.all([
              apiClient.models.Employee.listEmployeeByFileId(
                { fileId: file.id },
                { selectionSet: employeeSelectionSet }
              ),
              apiClient.models.Deposit.listDepositByFileId(
                { fileId: file.id },
                { selectionSet: depositSelectionSet }
              ),
              apiClient.models.FundContribution.listFundContributionByFileId(
                { fileId: file.id },
                { selectionSet: fundContributionSelectionSet }
              ),
            ]);

            return {
              ...file,
              employees: employeesResponse.data || [], 
              deposits: depositsResponse.data || [],
              fundContributions: fundContributionsResponse.data || [],
            };
          })
        );

        setFiles(filesWithRelatedData);
      } catch (error) {
        console.error('Error fetching files with related data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchFilesWithRelatedData();
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        gap: '20px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: '10px',
            alignItems: 'center',
            width: '100%',
          }}
        >

        </Box>
        <Typography
          fontSize="30px"
          fontWeight="700"
          fontFamily={'AlmoniDL'}
          textAlign={'right'}
          sx={{ whiteSpace: 'nowrap' }}
        >
          מעקב שיוכים
        </Typography>
      </Box>
      <Divider
        sx={{
          width: '100%',
          height: '1px',
          backgroundColor: theme.palette.dark.border,
        }}
      />
     {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
          <ReactLoading type="bubbles" color='#94C729' height={100} width={100} />
        </Box>
      ) : (
        <FileList files={files} />
      )}
    </Box>
  );
};

export default Assignments;
